import type { OrgRole, Position } from '@localagent/sdk';

export const ROLE_DISPLAY_NAMES: Record<OrgRole, string> = {
  ceo: 'CEO',
  vp: 'VP',
  director: 'Director',
  manager: 'Manager',
  ic: 'Individual Contributor',
};

export function occupantAgentName(position: Position): string {
  if (!position.agent_name) throw new Error(`position ${position.id} is staffed by agent ${position.agent_id} but carries no agent name`);
  return position.agent_name;
}
